"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    getHomePage: ()=>getHomePage,
    useGetHomePage: ()=>useGetHomePage
});
const _reactQuery = require("react-query");
const _ = require("../..");
const getHomePage = async (payload, opts)=>{
    const response = await _.api.get(`/wallet/v1/members/${payload.walletId}/home_pages`, opts);
    return response;
};
const useGetHomePage = (queryOptions = {})=>{
    const { walletId , firebaseToken  } = (0, _.useSpringBigStore)();
    return (0, _reactQuery.useQuery)('homepage', ({ signal  })=>getHomePage({
            walletId,
            firebaseToken
        }, {
            signal
        }), {
        ...queryOptions
    });
};
